export default __webpack_public_path__ + "static/media/fireFN16.67dbd220.svg";